(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _header = require("./view/_header");

var _header2 = _interopRequireDefault(_header);

var _loading = require("./view/_loading");

var _loading2 = _interopRequireDefault(_loading);

var _modal = require("./view/_modal");

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./view/_header":2,"./view/_loading":3,"./view/_modal":4}],2:[function(require,module,exports){
"use strict";

// menu open
$('#js-hamburger').click(function () {
  $(this).toggleClass('is-open');
  $('.l-navigation').toggleClass('is-open');
  $('html').toggleClass('is-fixed');
});

},{}],3:[function(require,module,exports){
'use strict';

$(window).on('load', function () {
  var _main = $('.p-front__map');

  var _wrapper = $('.p-front__figure');

  var _pinArea = $('.p-frontPin__wrapper');

  var _vh = window.innerHeight * 0.01;

  $('.p-front').css('--vh', _vh + "px");
  $('.p-front__figure').css('--vh', _vh + "px");
  $('.p-front__map').css('--vh', _vh + "px");

  _pinArea.css('--vh', _vh + "px");

  $('.p-frontLoading__image').addClass('-done');
  setTimeout(function () {
    _main.animate({
      opacity: '1'
    }, 500);
  }, 1000);
  setTimeout(function () {
    _main.css({
      'transform': 'none'
    });

    var _mainW = $('.p-front__map').width();

    var _mainH = $('.p-front__map').height();

    var _figureH = $('.p-front__figure').height();

    _pinArea.css({
      'width': _mainW
    });

    _pinArea.css({
      'height': _mainH
    });

    _pinArea.css({
      'top': (_figureH - _mainH) / 2
    });

    var _width = $(window).width();

    if (_mainW > _width) {
      var _margin = (_mainW - _width) / 2 - 20;

      _wrapper.scrollLeft(_margin);

      console.log(_margin);
    }
  }, 1000);
  setTimeout(function () {
    $('#js-loading').addClass('-done');
  }, 1000);
  setTimeout(function () {
    $('.l-header').animate({
      opacity: '1'
    }, 1000);
    $('.p-front__button').animate({
      opacity: '1'
    }, 1000);
  }, 1500);
  setTimeout(function () {
    _pinArea.animate({
      opacity: '1'
    }, 1000);
  }, 1500);
});
$(window).resize(function () {
  var _main = $('.p-front__map');

  var _wrapper = $('.p-front__figure');

  var _pinArea = $('.p-frontPin__wrapper');

  var _vh = window.innerHeight * 0.01;

  _main.css({
    opacity: '0',
    transition: 'none'
  });

  _pinArea.css({
    opacity: '0',
    transition: 'none'
  });

  $('.l-header').css({
    opacity: '0'
  });
  $('.p-front__button').css({
    opacity: '0'
  });
  setTimeout(function () {
    $('.p-front').css('--vh', _vh + "px");
    $('.p-front__figure').css('--vh', _vh + "px");
    $('.p-front__map').css('--vh', _vh + "px");

    _pinArea.css('--vh', _vh + "px");

    var _mainW = $('.p-front__map').width();

    var _width = $(window).width();

    var _mainH = $('.p-front__map').height();

    var _figureH = $('.p-front__figure').height();

    _pinArea.css({
      'width': _mainW
    });

    _pinArea.css({
      'height': _mainH
    });

    _pinArea.css({
      'top': (_figureH - _mainH) / 2
    });

    if (_mainW > _width) {
      var _margin = (_mainW - _width) / 2 - 20;

      _wrapper.scrollLeft(_margin);
    }
  }, 500);
  setTimeout(function () {
    _main.animate({
      opacity: '1'
    }, 1000);

    $('.l-header').animate({
      opacity: '1'
    }, 1500);
    $('.p-front__button').animate({
      opacity: '1'
    }, 1500);
  }, 1000);
  setTimeout(function () {
    _pinArea.animate({
      opacity: '1'
    }, 1000);
  }, 1500);
});

},{}],4:[function(require,module,exports){
"use strict";

$('.js-frontModalOpen').click(function () {
  if ($('.c-frontModal__overlay')[0]) return false;

  var _modal = $('.c-frontModal__body');

  var _target = $(this).data('target');

  var _image = $('#' + _target).find('.p-frontNavigation__image').attr('src');

  var _title = $('#' + _target).find('.p-frontNavigation__title').text();

  var _sub = $('#' + _target).find('.p-frontNavigation__sub').text();

  var _text = $('#' + _target).find('.p-frontNavigation__text').html();

  var _link = '';

  if ($('#' + _target).hasClass('-disable')) {
    _link = '';
  } else {
    _link = $('#' + _target).attr('href');
  }

  _modal.find('.c-frontModal__image').attr('src', _image);

  _modal.find('.c-frontModal__title').text(_title);

  _modal.find('.c-frontModal__sub').text(_sub);

  _modal.find('.c-frontModal__text').html(_text.replace(/\n/g, '<br>'));

  if (_link != '') {
    _modal.append('<a href="javascript:void(0);" class="c-button" id="js-next" data-next="' + _link + '">Let’s Go</a>');
  }

  $('body').append('<div class="c-frontModal__overlay"></div>');
  $('.c-frontModal__overlay').fadeIn('slow');

  _modal.fadeIn('slow');

  $('html').addClass('is-fixed');
  $('.c-frontModal__overlay, .js-frontModalClose').unbind().click(function () {
    $('html').removeClass('is-fixed');
    $('.c-frontModal__body,.c-frontModal__overlay').fadeOut('slow', function () {
      $('.c-frontModal__overlay').remove();

      _modal.find('.c-frontModal__image').attr('src', '');

      _modal.find('.c-frontModal__title').text('');

      _modal.find('.c-frontModal__sub').text('');

      _modal.find('.c-frontModal__text').text('');

      if ($('#js-next').length) {
        $('#js-next').remove();
      }
    });
  });
});
$(document).on('click', '#js-next', function () {
  var _next = $(this).data('next');

  $('.c-frontModal__overlay').addClass('is-loading');
  $('.c-frontModal__body').addClass('is-loading');
  setTimeout(function () {
    window.location.href = _next;
  }, 600);
});

},{}]},{},[1]);
